import React, { Component } from 'react';
import ColButton from '../../../Elements/ColButton';
import OfficeMultiSelect from '../../../Elements/OfficeMultiSelect';
import PanelBorder from '../../../Elements/PanelBorder';
import InputWithClear from '../../../Elements/InputComponents/InputWithClear';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import AddressSearchParams from './AddressSearchParams';

class SearchAddressPanel extends Component {
  static defaultProps = {
    searchItem: {},
    startSearch: () => alert('Empty function'),
  };

  constructor(props) {
    super(props);
    this.state = {
      searchItem: props.searchItem,
      advanced: false,
    };
  }

  componentDidMount() {}

  renderAdvancedSearchButton() {
    return (
      <ColButton
        text='Advanced Search'
        onClick={() => {
          this.setState({ advanced: !this.state.advanced });
        }}
        icon={this.state.advanced ? 'fa-solid fa-caret-up' : 'fa-solid fa-caret-down'}
      />
    );
  }

  changeOfSearchItem(fieldName, newValue) {
    var newSearchItem = {
      ...this.state.searchItem,
      [fieldName]: newValue,
    };
    this.setState({ searchItem: newSearchItem });
  }

  renderClearAllButton() {
    return (
      <ColButton
        text='Clear All'
        onClick={() => {
          var tempSearchItem = new AddressSearchParams();
          this.setState({ searchItem: tempSearchItem });
          this.props.startSearch(tempSearchItem);
        }}
        icon='fa-solid fa-eraser'
      />
    );
  }

  renderInputField(fieldName, labelText, colwidth, type, selectValues) {
    if (type === undefined) {
      type = InputTypesEnum.Text;
    }
    return (
      <div className={colwidth}>
        <InputWithClear
          fieldName={fieldName}
          labelText={labelText}
          type={type}
          value={this.state.searchItem[fieldName]}
          onChange={(fieldName, newValue) => this.changeOfSearchItem(fieldName, newValue)}
          selectValues={selectValues}
        />
      </div>
    );
  }

  renderOfficeMultiselect(labelText, colwidth) {
    return (
      <div className={colwidth}>
        <div className='text-center '>{labelText}</div>
        <OfficeMultiSelect
          selectedOfficeIds={this.state.searchItem.SelectedOfficeIds}
          numberOfCols={2}
          onChange={(officeIds) => {
            let tempSearchItem = { ...this.state.searchItem, SelectedOfficeIds: officeIds };
            this.setState({ searchItem: tempSearchItem });
          }}
        />
      </div>
    );
  }

  render() {
    return (
      <PanelBorder
        headerText='Searching for Address'
        clickOnCancel={this.props.clickOnCancel}
        icon='fa-solid fa-search'
        itemToSave={this.state.searchItem}
        saveType='AddressSearchParams'
        onSavedItemChanged={(item) => {
          this.setState({ searchItem: item });
          this.props.startSearch(item);
        }}
        saveWindowText='Save Address Search Template'
        openWindowText='Open Address Search Template'
      >
        <form
          onSubmit={(e) => {
            e.preventDefault();
            this.props.startSearch(this.state.searchItem);
          }}
        >
          <div className=''>
            <div className='row'>
              {this.renderInputField('AddressId', 'Address Id', 'col')}
              {this.renderInputField('Name', 'Name', 'col')}
              {this.renderInputField('City', 'City', 'col')}
            </div>
            {this.state.advanced && (
              <div className='row'>
                {this.renderInputField('State', 'State', 'col')}
                {this.renderInputField('Line1', 'Street', 'col')}
                {this.renderInputField('CountryId', 'Country', 'col', InputTypesEnum.CountrySelect)}
                {this.renderInputField('IsActive', 'Is Active', 'col', InputTypesEnum.EmptyYesNoSelect)}
              </div>
            )}

            <div className='row'>
              {this.renderAdvancedSearchButton()}
              {this.renderClearAllButton()}
              <ColButton
                text='Start Search'
                type='submit'
                icon='fa-solid fa-search'
              />
            </div>
          </div>
        </form>
      </PanelBorder>
    );
  }
}

export default SearchAddressPanel;
